import React from 'react';
import MyAccountOrdersPanel from './MyAccountOrdersPanel';
import MyAccountInvoiceHistoryPanel from './MyAccountInvoiceHistoryPanel';
import ProductSearchForm from './ProductSearchForm';
import ProductCategories from './ProductCategories';
import AccountSummary from './AccountSummary';
import MyAccountCard from './MyAccountCard';

interface MyAccountDashboardProps {
    userName?: string;
    showProducts?: boolean;
    showOrders?: boolean;
    showInvoices?: boolean;
    showAccountSummary?: boolean;
}

const MyAccountDashboard: React.FC<MyAccountDashboardProps> = ({
    userName = 'User',
    showProducts = true,
    showOrders = true,
    showInvoices = true,
    showAccountSummary = true
}) => {
    return (
        <div className='row'>
            <div className='col-12 col-lg-8'>
                <MyAccountCard
                    variant="page"
                    slug="dashboard-main"
                    wrapContent={false}
                >
                        {/* <p className="mb-3">
                            Hello <strong>{userName}</strong> (not <strong>{userName}</strong>?{' '}
                            <a href="/customer-logout/">Log out</a>
                        </p> */}

                        {/* Account Summary */}
                        {showAccountSummary && (
                            <div className="row g-3 mb-3">
                                <div className="col-12">
                                    <AccountSummary />
                                </div>
                            </div>
                        )}
                    
                        <div className="row g-3">
                            {/* Left Column - Find Products */}
                            {showProducts && (
                                <div className="col-12 col-xl-12">
                                    <div className="portal-panel">
                                        <div className="">
                                            {/* <h5 className="card-title">Find Products</h5> */}
                                            {/* <ProductSearchForm /> */}
                                        </div>
                                    </div>
                                    
                                    {/* Product Categories Grid */}
                                    <div className="portal-panel mt-3">
                                        <div className="">
                                            <ProductCategories />
                                        </div>
                                    </div>
                                </div>

                                
                            )}
                        </div>

                        
                </MyAccountCard>
            </div>
            {(showOrders || showInvoices) && (
                <div className='col-12 col-lg-4'>
                    {showOrders && (
                        <MyAccountCard
                            variant="page"
                            slug="dashboard-recent-orders"
                            className="mb-3"
                            wrapContent={false}
                        >
                            <MyAccountOrdersPanel
                                maxOrders={5}
                                showHeader={true}
                                title="Recent Orders"
                            />
                        </MyAccountCard>
                    )}

                    {showInvoices && (
                        <MyAccountCard
                            variant="page"
                            slug="dashboard-recent-invoices"
                            wrapContent={false}
                        >
                            <MyAccountInvoiceHistoryPanel
                                maxInvoices={5}
                                showHeader={true}
                                title="Recent Invoices"
                            />
                        </MyAccountCard>
                    )}
                </div>
            )}
            
        </div>
        
        
    );
};

export default MyAccountDashboard;
